import { AddressLine } from '@/settings/domain/address/AddressLine';
import { Entity } from '@/settings/domain/entity/entity/Entity';
import { ShippingMethod } from '@/settings/domain/shippingMethod/ShippingMethod';
import { TypeOperation } from '@/settings/domain/typeOperation/TypeOperation';
import { Warehouse } from '@/settings/domain/warehouse/Warehouse';
import { TimelineConfig } from '@/tracking/domain/timelineConfig/TimelineConfig';
import { Transport } from '@/tracking/domain/typetransport/Transport';
import { Bulk } from '../bulk/Bulk';
import { TrackingNumber } from '../trackingNumber/TrackingNumber';
import { PreRegisterStatusEnum } from './PreRegisterStatusEnum';

export class PreRegister {
  typeOperationData: TypeOperation | null;
  typeOperation: number;
  shippingMethod: ShippingMethod | null;
  typeTransport: Transport | null;
  warehouse: Warehouse | null;
  number: string;
  trackingNumber: TrackingNumber | null;
  container: string;
  date: string;
  sender: Entity | null;
  recipient: Entity;
  address: AddressLine;
  addressDestination: AddressLine;
  cargoTo: Entity | null;
  transportistName: string;
  transportistId: string;
  deliveryName: Entity | null;
  licensePlate: string;
  bulks: Bulk[];
  notes: string;
  receivedBy: string;
  cubedBy: string;
  type: string;
  state: string;
  estimatedArrivalDate: string;
  lastNumber: string;
  lastType: string;
  timeline: TimelineConfig | null;

  public constructor() {
    this.typeOperationData = null;
    this.typeOperation = 1;
    this.shippingMethod = null;
    this.typeTransport = null;
    this.warehouse = null;
    this.number = '0';
    this.trackingNumber = null;
    this.container = '';
    this.date = '';
    this.sender = null;
    this.recipient = new Entity();
    this.address = new AddressLine();
    this.addressDestination = new AddressLine();
    this.cargoTo = null;
    this.transportistName = '';
    this.transportistId = '';
    this.deliveryName = null;
    this.licensePlate = '';
    this.bulks = [];
    this.notes = '';
    this.receivedBy = '';
    this.cubedBy = '';
    this.type = '';
    this.state = PreRegisterStatusEnum.PARTIAL_PRE_REGISTER;
    this.estimatedArrivalDate = '';
    this.lastNumber = '0';
    this.lastType = '';
    this.timeline = null;
  }
}
